import { ActionTree } from "vuex";
import { State } from "./state";
import { create, update, findAll, findOne, del, filter } from "@/store/Crud/functions/actions";
import { archive } from "@/store/Crud/functions/archived/actions";

import {
  updateParticipantsList,
  book,
  uploadProtocol,
  updateExamStatus,
  resetSave,
  resetExamStatus,
  resetBooking,
  resetParticipantList,
  ready,
  removeStudentFromExam,
  getExamTheoryPracticeInfo,
} from "@/store/Exam/actions";

export default <ActionTree<State, any>>{
  create,
  update,
  findAll,
  findOne,
  updateParticipantsList,
  archive,
  book,
  uploadProtocol,
  updateExamStatus,
  resetSave,
  resetExamStatus,
  resetBooking,
  resetParticipantList,
  ready,
  removeStudentFromExam,
  del,
  getExamTheoryPracticeInfo,
  filter,
};
